export const P = {
	// Page-level READ permissions
	MERCHANT_READ: "MERCHANT_READ",
	FIAT_EXCHANGE_RATE_READ: "FIAT_EXCHANGE_RATE_READ",
	EVENT_SERVICE_INFO_READ: "EVENT_SERVICE_INFO_READ",
	FIAT_DISTRIBUTION_READ: "FIAT_DISTRIBUTION_READ",
	FIAT_WITHDRAWAL_ORDER_READ: "FIAT_WITHDRAWAL_ORDER_READ",
	FIAT_CHECKOUT_ORDER_READ: "FIAT_CHECKOUT_ORDER_READ",
	FIAT_PAYOUT_GATEWAY_BALANCE_READ: "FIAT_PAYOUT_GATEWAY_BALANCE_READ",
	CRYPTO_WALLET_READ: "CRYPTO_WALLET_READ",
	FIAT_WALLET_READ: "FIAT_WALLET_READ",

	// Button-level permissions
	MERCHANT_CREATE: "MERCHANT_CREATE",
	MERCHANT_UPDATE: "MERCHANT_UPDATE",
	MERCHANT_PASSWORD_UPDATE: "MERCHANT_PASSWORD_UPDATE",
	MERCHANT_FIAT_ACCOUNT_UPDATE: "MERCHANT_FIAT_ACCOUNT_UPDATE",
	MERCHANT_CRYPTO_CURRENCY_CREATE: "MERCHANT_CRYPTO_CURRENCY_CREATE",
	MERCHANT_CRYPTO_CURRENCY_UPDATE: "MERCHANT_CRYPTO_CURRENCY_UPDATE",
	FIAT_EXCHANGE_RATE_UPDATE: "FIAT_EXCHANGE_RATE_UPDATE",
	FIAT_WITHDRAWAL_ORDER_CREATE: "FIAT_WITHDRAWAL_ORDER_CREATE",
	FIAT_WITHDRAWAL_ORDER_UPDATE: "FIAT_WITHDRAWAL_ORDER_UPDATE",
} as const;

export type PermissionKey = (typeof P)[keyof typeof P];

export const ROUTE_PERMISSION_MAP: Record<string, string> = {
	"/pw_management/merchant": P.MERCHANT_READ,
	"/pw_management/checkout_orders": P.FIAT_CHECKOUT_ORDER_READ,
	"/pw_management/wallets": "", // special: handled by CRYPTO_WALLET_READ || FIAT_WALLET_READ
	"/pw_management/rate": P.FIAT_EXCHANGE_RATE_READ,
	"/pw_management/pos_event": P.EVENT_SERVICE_INFO_READ,
	"/pw_management/fiat_distribution": P.FIAT_DISTRIBUTION_READ,
	"/pw_management/payout_gateway_balances": P.FIAT_PAYOUT_GATEWAY_BALANCE_READ,
	"/pw_management/withdrawal_orders": P.FIAT_WITHDRAWAL_ORDER_READ,
};

export const NAV_PERMISSION_MAP: Record<string, string | string[]> = {
	"/pw_management/merchant": P.MERCHANT_READ,
	"/pw_management/checkout_orders": P.FIAT_CHECKOUT_ORDER_READ,
	"/pw_management/wallets": [P.CRYPTO_WALLET_READ, P.FIAT_WALLET_READ],
	"/pw_management/rate": P.FIAT_EXCHANGE_RATE_READ,
	"/pw_management/pos_event": P.EVENT_SERVICE_INFO_READ,
	"/pw_management/fiat_distribution": P.FIAT_DISTRIBUTION_READ,
	"/pw_management/payout_gateway_balances": P.FIAT_PAYOUT_GATEWAY_BALANCE_READ,
	"/pw_management/withdrawal_orders": P.FIAT_WITHDRAWAL_ORDER_READ,
};

const HOMEPAGE_CANDIDATES = [
	"/pw_management/merchant",
	"/pw_management/checkout_orders",
	"/pw_management/wallets",
	"/pw_management/rate",
	"/pw_management/pos_event",
	"/pw_management/fiat_distribution",
	"/pw_management/payout_gateway_balances",
	"/pw_management/withdrawal_orders",
];

export function getFirstPermittedPath(permissions: string[]): string {
	for (const path of HOMEPAGE_CANDIDATES) {
		const required = NAV_PERMISSION_MAP[path];
		if (Array.isArray(required)) {
			if (required.some((p) => permissions.includes(p))) return path;
		} else if (required && permissions.includes(required)) {
			return path;
		}
	}
	return "/403";
}
